var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoupe = function SvgLoupe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 60 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49c-3.1 0-6.2-.6-9.2-1.8-6-2.4-10.8-7.1-13.3-13.1C-3.3 21.6 2.5 7.2 14.9 2c6-2.6 12.7-2.6 18.7-.2C39.7 4.2 44.5 8.9 47 14.9c2.6 6 2.6 12.7.2 18.7-2.4 6.1-7.1 10.8-13.1 13.4-3.1 1.3-6.4 2-9.6 2zm0-45.7c-2.8 0-5.6.6-8.3 1.7C5.5 9.6.4 22 5 32.8 7.2 38 11.3 42 16.6 44.1c5.2 2.1 11 2.1 16.2-.1h0c5.2-2.2 9.2-6.3 11.3-11.6 2.1-5.2 2.1-11-.1-16.2S37.6 7 32.4 4.9c-2.6-1.1-5.2-1.6-7.9-1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3 60c-.4 0-.8-.2-1.2-.5L39.4 41.8c-.6-.6-.6-1.7 0-2.3s1.7-.6 2.3 0l17.7 17.7c.6.6.6 1.7 0 2.3-.2.3-.7.5-1.1.5z"
  })));
};
export default SvgLoupe;